module.exports = __webpack_public_path__ + "static/img/flag-united-states.2741439.svg";


//////////////////
// WEBPACK FOOTER
// ./static/images/flag-united-states.svg
// module id = f2wA
// module chunks = 1